export const UPGRADE_CHECK = "upgrade/UPGRADE_CHECK";



// WEBPACK FOOTER //
// ./app/modules/Upgrade/actionTypes.js